var _style, _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.98 362.98",
    style: {
      enableBackground: "new 0 0 362.98 362.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A3CAB5;}\n\t.st1{fill:none;stroke:#A3CAB5;stroke-width:20;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#A3CAB5;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:15;}\n\t.st3{fill:#C8DFD3;}\n\t.st4{fill:none;stroke:#C8DFD3;stroke-width:20;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#B5D5C4;stroke-width:25;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#A3CAB5;stroke-width:25;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#DAEAE1;stroke-width:25;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.41,362.98h-0.01C81.33,362.93-0.05,281.47,0,181.4c0.02-48.48,18.92-94.04,53.22-128.31 C87.49,18.85,133.05,0,181.49,0c0.03,0,0.06,0,0.09,0c48.44,0.02,93.99,18.9,128.24,53.16c34.25,34.25,53.13,79.8,53.16,128.24 c-0.03,48.5-18.93,94.08-53.21,128.37C275.48,344.05,229.9,362.95,181.41,362.98z M181.49,20c-43.11,0-83.63,16.77-114.13,47.24 C36.84,97.73,20.02,138.27,20,181.41s16.76,83.7,47.24,114.21c30.48,30.51,71.03,47.33,114.16,47.36 c89.04-0.06,161.52-72.54,161.58-161.58C342.94,92.45,270.53,20.04,181.57,20C181.54,20,181.51,20,181.49,20z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.43,300.11c-65.51-0.03-118.59-53.17-118.56-118.68c0.03-65.51,53.17-118.59,118.68-118.56 c65.47,0.03,118.53,53.1,118.56,118.56C300.07,246.96,246.96,300.07,181.43,300.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M182.89,133.21c-7.73-9.97-25.56-0.51-34.79,13.21c-6.59,9.81-14.4,7.59-22.98,13.11 c-11.5,7.41-22.48,22.68-6.65,49.07c14.57,24.28,38.92-9.28,51.88-7.41c23.39,3.36,23.77,26.58,44.22,26.07 c20.45-0.51,33.99-31.18,27.6-44.73c-6.39-13.55-11.65-15.07-16.87-31.95c-7.67-24.79-17.38-29.39-20.19-8.69 C202.31,162.6,192.49,145.58,182.89,133.21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M221.28,234.5c-4.65,0.7-10.86-1.33-9.31,3.55s5.32,13.08,9.31,8.43C225.27,241.82,228.59,233.39,221.28,234.5z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFour);
export default __webpack_public_path__ + "static/media/image_four.395a9787ab58c7a8ee579aa945aa34ea.svg";
export { ForwardRef as ReactComponent };